// extracted by mini-css-extract-plugin
export default {"ipa":"ipa_NFsD","interactive":"interactive_lIp_","audioPlaying":"audioPlaying_f_1k"};